'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _scrollparent = require('scrollparent');

var _scrollparent2 = _interopRequireDefault(_scrollparent);

var _domUtil = require('../../utils/domUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollMonitor = function (_React$Component) {
  (0, _inherits3.default)(ScrollMonitor, _React$Component);

  function ScrollMonitor() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ScrollMonitor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ScrollMonitor.__proto__ || (0, _getPrototypeOf2.default)(ScrollMonitor)).call.apply(_ref, [this].concat(args))), _this), _this.checkViewport = function () {
      if (!_this.node) {
        return;
      }

      if (_this.props.enterViewport && (0, _domUtil.inView)(_this.node)) {
        if (!_this._didNotify) {
          _this._didNotify = true;
          _this.props.enterViewport();
        }
      } else {
        _this._didNotify = false;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ScrollMonitor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var node = this.node = (0, _reactDom.findDOMNode)(this);
      var parent = this.scrollingParent = (0, _scrollparent2.default)(node);
      if (parent) {
        parent.addEventListener('scroll', this.checkViewport);
      }
      setTimeout(function () {
        _this2.checkViewport();
      }, 30);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.checkViewport();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.scrollingParent) {
        this.scrollingParent.removeEventListener('scroll', this.checkViewport);
      }

      delete this.node;
      delete this.scrollingParent;
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return ScrollMonitor;
}(_react2.default.Component);

exports.default = ScrollMonitor;


ScrollMonitor.propTypes = {
  enterViewport: _propTypes2.default.func,
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/ScrollMonitor/index.js
// module id = 624
// module chunks = 0